import { Helmet } from 'react-helmet-async';

interface PostMetaTagsProps {
  post: {
    caption?: string;
    media?: Array<{ url: string }>;
    pet?: {
      name?: string;
    };
  };
}

export const PostMetaTags = ({ post }: PostMetaTagsProps) => {
  const imageUrl = post.media?.[0]?.url || '/lovable-uploads/3ac076b3-374a-496b-9d19-4734148282dd.png';
  const title = post.pet?.name 
    ? `${post.pet.name} en Petius - Comparte el amor por las mascotas` 
    : 'Petius - Comparte el amor por las mascotas';
  const description = post.caption 
    ? post.caption.substring(0, 160) 
    : `Mira esta adorable foto de ${post.pet?.name || 'mascota'} en Petius`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:site_name" content="Petius" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* WhatsApp specific */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
};
